function shouldShowDevBanner(): boolean {
  const viteEnv = import.meta.env.VITE_ENV?.toLowerCase();

  if (viteEnv === "production") {
    return false;
  }

  if (
    viteEnv === "development" ||
    viteEnv === "dev" ||
    viteEnv === "preview"
  ) {
    return true;
  }

  return import.meta.env.DEV;
}

export function DevBanner() {
  if (!shouldShowDevBanner()) {
    return null;
  }

  return (
    <>
      <div
        role="status"
        aria-live="polite"
        className="pointer-events-none fixed inset-x-0 top-0 z-[100] flex h-6 items-center justify-center bg-orange-500 text-xs font-semibold tracking-wide text-white antialiased"
      >
        Données de test
      </div>
      <div className="h-6 shrink-0" aria-hidden="true" />
    </>
  );
}
